export const getTopLink = () => '/';
// client
export const getClientsLink = () => '/clients';
export const getClientNewLink = () => '/clients/new';
export const getClientLink = (id: number) => `/clients/${id}`;
export const getClientEditLink = (id: string) => `/clients/${id}/edit`;
// client-admin
export const getClientAdminUsersLink = () => '/client-admins';
export const getClientAdminUserLink = (id: number) => `/client-admins/${id}`;
export const getClientAdminUserEditLink = (id: string) => `/client-admins/${id}/edit`;
// user
export const getUsersLink = () => '/users';
export const getUserLink = (id: number) => `/users/${id}`;
export const getUserEditLink = (id: string) => `/users/${id}/edit`;
// service
export const getServicesLink = () => '/services';
export const getServiceLink = (id: number) => `/services/${id}`;
// top-banner
export const getTopBannersLink = () => '/top-banners';
export const getTopBannerEditLink = (id: string) => `/top-banners/${id}/edit`;
export const getTopBannerCreateLink = () => '/top-banners/new';
// service-report
export const getServiceReportLink = () => '/service-report';
// login-report
export const getLoginReportLink = () => '/login-report';

export const getPushNotificationLink = () => '/push-notifications';
export const getCreatePushNotificationLink = () => '/push-notifications/create';
// groups
export const getGroupsLink = () => '/groups';
export const getGroupLink = (id: number) => `/groups/${id}`;
export const getGroupsNewLink = () => '/groups/new';
export const getGroupEditLink = (id: string) => `/groups/${id}/edit`;
// contract-plans
export const getContractPlansLink = () => '/contract-plans';
export const getContractPlanLink = (id: number) => `/contract-plans/${id}`;
// client-contracts
export const getClientContractListLink = () => '/client-contracts';
export const getClientContractTermDetailLink = ({
  clientId,
  termId,
}: {
  clientId: number;
  termId: number;
}) => `/clients/${clientId}/client-contracts/${termId}`;
export const getClientContractTermEditLink = ({
  clientId,
  termId,
}: {
  clientId: number;
  termId: number;
}) => `/clients/${clientId}/client-contracts/${termId}/edit`;
